import type { ReactNode } from 'react'
import { Accordion, Box, Heading } from '@chakra-ui/react';

export function AudienceGroup({ title, defaultOpen, children }: { title: string; defaultOpen?: boolean; children: ReactNode }) {
  return (
    <Accordion.Root collapsible defaultValue={defaultOpen ? ['item-0'] : []}>
      <Accordion.Item
        border="1px solid"
        borderColor="gray.200"
        borderRadius="md"
        value='item-0'>
        <Accordion.ItemTrigger><Box flex="1" textAlign="left"><Heading size="sm">{title}</Heading></Box><Accordion.ItemIndicator /></Accordion.ItemTrigger>
        <Accordion.ItemContent pb={4}><Accordion.ItemBody>{children}</Accordion.ItemBody></Accordion.ItemContent>
      </Accordion.Item>
    </Accordion.Root>
  );
}
